import initialState from "../../../store/initialState";
import types from "./inputFileUpperTypes";


export const cargarDocumentoReducer = (state = initialState.documentos, action) => {
  switch (action.type) {
    case types.ARCHIVO_CARGANDO:
      return {
        ...state,
        documentosCargados: state.documentosCargados.map(documentosCargados =>
          documentosCargados.id === action.payload.id ? { 
            ...documentosCargados, 
            estado: "Adjuntando",
            file: null,
            error:null 
          } : documentosCargados
        )
      };
    case types.ARCHIVO_CARGADO:
      return {
        ...state,
        documentosCargados: state.documentosCargados.map(documentosCargados =>
          documentosCargados.id === action.payload.id ? { 
            ...documentosCargados, 
            estado: "Volver a adjuntar",
            file: action.payload.file,
            url: action.payload.url,
            extension: action.payload.extension,
            VisorPDF: action.payload.extension==='pdf' ? true:!true,
            error:null 
          } : documentosCargados
        )
      };
    case types.ARCHIVO_ERROR:
      return {
        ...state,
        documentosCargados: state.documentosCargados.map(documentosCargados =>
          documentosCargados.id === action.payload.id ? { 
            ...documentosCargados, 
            estado: "Adjuntar",
            file: null,
            error: action.payload.error
          } : documentosCargados
        )
      };
    default:
      return state;
  }
}


export default cargarDocumentoReducer;